<template>
  <div class="page" v-wechat-title="$route.meta.title='所有解说'">
    <div class="station-top-bar border-box box">
      <router-link class="station-location" v-if="!siteid || !sregion" to="/city">
        <span class="station-location-name">{{cityInfo.city || '全国'}}</span>
        <img class="station-location-icon" src="../../assets/icon-down.png" alt="">
      </router-link>

      <div class="station-search-box flex">
        <form class="station-search-bar border-box" v-on:submit.prevent="search()">
          <img class="station-search-icon" src="../../assets/icon-search.png" alt="" @click='search()'>
          <input type="text" class="station-search-input"  placeholder="搜索景区" value="" v-model='inputValue'  />
          <img class="station-input-close" src="../../assets/input-close.png" alt="" v-show="inputValue"  @click="inputValue=''">
        </form>
      </div>
    </div>

    <div class="split-line h13"></div>

    <div class="station list-tab box">
      <div v-for="(item,index) in tabList" class="flex" :class="cid == item.id ? 'curr': ''" @click='search(item.id)'>
        <span class="bottom-bor">{{item.name}}</span>
      </div>
    </div>

    <!--<VoiceLi></VoiceLi>-->
    <div class="list border-box">
      <template v-for="(item,index) in bagList">
        <div class="list-box box" @click="goVideoPlay(index)">
          <!--左侧头像部分-->
          <div class="block list-img">
            <!--解说员头像-->
            <!--<img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="" @click.stop="goGuideInfo(item.id)">-->
            <img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="">
            <!--头像底部语音播放 -->
            <router-link class="listen-btn-num" :to="{path:'/video-play',query: {id:item.id,spotid:item.spotid,shopid:item.shopid, TimeStamp: TimeStamp, appKey: appKeyA}}" v-if="item.buy==12||item.price==0||item.isuser">
              <img src="../../assets/icon-listen.png" alt="">
              <span>收听</span>
            </router-link>
            <div class="listen-btn-num" @click.stop="listenTurlClick(index)" v-else>
              <img :src="item.isplay==1?require('../../assets/icon_listen02.gif'):require('../../assets/icon-listen.png')" alt="">
              <span>{{item.isplay==1?item.resTime+"'":"试听"}}</span>
            </div>
          </div>
          <!--右侧语音内容部分-->
          <div class="block flex list-info">
            <!--语音名称-->
            <div class="list-name guide-name hide">{{item.guidename2?item.guidename2:item.guidename}}
              <span v-if="item.guidetag">{{item.guidetag}}</span>
            </div>
            <div class="list-group hide">
              <span class="fl hide">{{item.name}}</span>
              <span v-if="item.label" class="label-color label-type">{{item.label}}</span>
            </div>
            <!--标签-->
            <div class="mt6 clearfix">
              <div v-if="item.listen>0" class="label-color">
                <img src="../../assets/icon-label-listen.png" alt="">
                <span>{{item.listen|initNumber}}人收听</span>
              </div>
              <div v-if="item.buynum>0" class="label-color">
                <img src="../../assets/icon-label-buy.png" alt="">
                <span>{{item.buynum|initNumber1}}人购买</span>
              </div>
              <div v-if="item.buynum<=0&&item.dsnum>0&&item.noReward!=1" class="label-color">
                <img src="../../assets/icon-label-buy.png" alt="">
                <span>{{item.dsnum|initNumber}}人打赏</span>
              </div>
            </div>
            <div class="sees-num-block clearfix">
              <div class="label-color">
                <img src="../../assets/icon-label-sees.png" alt="">
                <span>包含{{item.sees}}个讲解点</span>
              </div>
            </div>
            <!--价格-->
            <div class="price-text-box clearfix">
              <div class="price-text">
                <div v-if="item.price!=0">{{item.price}}元<span class="sees-num-inline">(包含{{item.sees}}个讲解点)</span></div>
                <div v-else>打赏<span class="sees-num-inline">(包含{{item.sees}}个讲解点)</span></div>
              </div>
            </div>
            <!--右侧购买收听按钮-->
            <button class="btn buy-btn buy-btn1" @click.stop="goVideoPlay(index)">详情</button>
            <button v-if="(item.buy==12)||(item.isuser)" class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index)">收听</button>
            <button v-else-if="item.price==0" class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'rewardShow')">打赏</button>
            <!--<button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideo(index)">购买/激活</button>-->
            <button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideo(index)">购买</button>
          </div>
        </div>
      </template>

      <p class="load-tip" ref="loadtip">{{loadText}}</p>
    </div>

    <!--试听结束弹窗新版-->
    <AlertListenEnd  :bag="bag" :couponid="couponid" :extral="extral" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

  </div>
</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import {getHomeBag} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo, listenEndOrder, listenTurl, creatOrder, pushOrder} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertListenEnd from '../../components/AlertListenEnd'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        siteid: '', //站点id
        userInfo: {}, //用户信息
        latlng: {}, //经纬度信息
        cityInfo: {}, //城市信息
        bagList:[],//语音列表
        total: '',//语音总数
        inputValue: '',//搜索关键词
        page: 1,
        rows: 10,
        loadText: "数据加载中",

        cid: 18, //当前类型
        tabList: [{
          name: "专业解说",
          id: 18
        }, {
          name: "明星解说",
          id: 20
        }, {
          name: "学者解说",
          id: 19
        }, {
          name: "达人解说",
          id: 21
        }], // 分类栏数据

        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey:'',
        appKeyA: ''
      }
    },
    computed: {

    },
    created() {
      let self = this;

      this.$loading.show('数据加载中');
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.inputValue = (this.$route.query.inputValue && this.$route.query.inputValue.replace(/(^\s*)|(\s*$)/g, "")) || "";
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if(this.siteid != "" && this.siteid != null && this.siteid != undefined ){
        setStore("siteid",this.siteid);
      }
      this.userInfo = getStore("userInfo");
      this.sregion = getStore("sregion") || '';

      let cityInfo = getStore("cityInfo");
      if(cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == ""  ){
        getCityInfo(function(res){
          self.latlng = res;
          self.cityInfo = getStore("cityInfo");
          self.initData(self.page);
        });
      }else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function(res){
          self.latlng ={ lat: res.latitude, lng: res.longitude };
          self.initData(self.page);
        });
      }

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun);
      if(this.videoTimer){
        clearInterval(this.videoTimer);
        this.currIndex = -1;
        this.bagList[this.index1].isplay = 0;
        this.bag = {};
      }
    },
    methods: {
      async initData(page){

        let res = await getHomeBag({
          TimeStamp: this.TimeStamp,
          siteid: this.siteid,
          code: this.cityInfo.citycode,
          page: page,
          rows: this.rows,
          type: 0, //0:热门 1:距离排序
          onlyshop: 0, //1:需要景区数据
          onlybag: 1, //1:需要导游数据
          name: this.inputValue, //搜索关键词
          cid: this.cid, //导游筛选
          openid: this.userInfo.openid,
          sregion: this.sregion
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.bagcount
          for(var i=0; i<res.data.baglist.length; i++){
            res.data.baglist[i].isplay = 0;
            res.data.baglist[i].toaTime = '';
            res.data.baglist[i].resTime = '';
          }
          let bagList = res.data.baglist;
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (bagList.length > 0) {
            this.bagList = [...this.bagList, ...bagList];
          } else {
            if (page == 1) {
              this.bagList = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          let title = this.userInfo.name + '@你：';
          let desc = '我正在“金牌解说”，一起来听景区故事吧';
          let link = '/voice-list?siteid='+ this.siteid +'&TimeStamp='+ this.TimeStamp +'&inputValue='+ this.inputValue+'&appKey='+(this.appKey);
          wxShareme(title,desc,"",link);

        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      //发送搜索信息inputVaule
      search(cid){
        if(this.videoTimer != null){
          this.Audio.pause();
          clearInterval(this.videoTimer);
        }
        this.currIndex = -1;
        for(var i=0; i<this.bagList.length; i++){
          this.bagList[i].isplay = 0;
        }
        this.bag = {};

        this.$loading.show('数据加载中');
        this.page = 1;
        this.bagList = [];

        if(cid){
          this.cid = cid
        }
        this.initData(this.page);
      },

      //点击试听，调用试听公用方法
      listenTurlClick(ind){
        listenTurl(this,ind,this.bagList)
      },

      //点击购买，调用下订单公用方法
      buyVideo(ind){
        let self = this;

        setStore("source", {"source": "index"})
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+self.bagList[ind].id+'&cid='+self.couponid+'&shopid='+self.bagList[ind].shopid+'&bagtype=0'+'&appKey='+self.appKey}`
        });

//        creatOrder(this,this.bagList[ind],"",function(data){
//          if(data){
//            setTimeout(function() {
//              self.bagList[self.index1].buy = 12;
//              self.bag = {};
//
//              pushOrder('dist/index.htmlJH/video-play?id='+self.bagList[ind].id+'ANDspotid='+self.bagList[ind].spotid+'ANDshopid='+self.bagList[ind].shopid + 'ANDTimeStamp='+ self.TimeStamp + 'ANDappKey='+ self.appKey);
//            }, 500)
//          }
//        })
      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if(msg.isbuy){
          this.bagList[this.index1].buy = 12;
        }
      },

      //跳转到专辑详情页
      goVideoPlay(ind,rewardShow){
        if(rewardShow){
          this.$router.push({
            path: `/video-play?${'id='+this.bagList[ind].id+'&spotid='+this.bagList[ind].spotid+'&shopid='+this.bagList[ind].shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&rewardShow=1'}`
          });
        }else {
          this.$router.push({
            path: `/video-play?${'id='+this.bagList[ind].id+'&spotid='+this.bagList[ind].spotid+'&shopid='+this.bagList[ind].shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }
      },

      //跳转到导游详情页
      goGuideInfo(id){
        this.$router.push({
          path: `/guide-info?${'id='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+this.appKey}`
        });
      },

    },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){
          listenEndOrder(this,this.index1,this.bagList);
        }
      },
      'cityInfo.citycode'(newVal,oldval){
        if(newVal != oldval){
//          this.initData();
        }
      },
    },
    components: {
      AlertListenEnd
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      initNumber1: function (num) { //重置购买数据
        if(num>=1000){
          num = '1000+'
        }
        return num;
      }
  }

  }

</script>

<style scoped>
  @import "../../style/voice.css";
  .page{padding-top: 1rem;}
  .station.list-tab {position:relative;height:.84rem;line-height:.84rem;border-top:2px solid #f2f2f2;border-bottom:1px solid #f2f2f2; }
  .station.list-tab .flex{position:relative;height:.84rem;line-height:.84rem;text-align: center;color: #767676;}
  .station.list-tab .flex span{display:inline-block;position:relative;height:.84rem;line-height:.84rem;}
  .station.list-tab .flex.curr{color: #000;}
  .station.list-tab .flex.curr:after{content:'';position:absolute;bottom:0;left:50%;right:0;width:.24rem;height:.12rem;background:#f8ab39;border-radius: .12rem .12rem 0 0;transform: translateX(-50%);z-index:1;}

</style>



// WEBPACK FOOTER //
// src/page/voice-list/voice-list.vue